import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageKeys } from '../config/storage-keys';
import { SessionStorageService } from '../services/session-storage.service';

export const httpTokenInterceptor: HttpInterceptorFn = (request, next) => {
	const sessionStorageService = inject(SessionStorageService);

	const token = sessionStorageService.getItem(StorageKeys.ACCESS_TOKEN);
	if (token) {
		let headers = request.headers.set('Authorization', `Bearer ${token}`);
		headers = headers.set('Accept', 'application/json,application/xml;q=0.9,*/*;q=0.8');
		if (!(request.body instanceof FormData)) {
			headers = headers.set('Content-Type', 'application/json');
		}
		request = request.clone({ headers });
	}
	return next(request);
};
